import React from "react";
import { navigate } from "gatsby";

import useWindowDimensions from "../../../hooks/useWindowDimensions";

import { socialButtons } from "../../../constants/enums";
import ICONS from "../../../constants/icons";
import ICON_SIZE from "../../icon/enums";
import MENU_PATHS from "../../../constants/menu";

import { IconButton } from "../../buttons";
import Button from "../../buttons/Button";

const SocialInfo = () => {
  const { isSmallScreen } = useWindowDimensions();

  const handleInvest = () => {
    navigate(MENU_PATHS.CONTACT);
  };

  const handleClick = (path: string) => {
    window.open(path, "_blank");
  };

  return (
    <div
      className={`-row-gap20 ${
        !isSmallScreen ? "column" : "column aligned-center -mb20"
      }`}
    >
      <IconButton
        handleClick={() => navigate(MENU_PATHS.HOMEPAGE)}
        name={ICONS.LOGO}
        aria={{
          label: "Footer logo image",
        }}
      />
      <p className="text-white">Verified Skills and Digital Logs</p>

      <div className="-column-gap20 aligned-start">
        {socialButtons.map(({ id, iconName, path }) => (
          <IconButton
            key={id}
            handleClick={() => handleClick(path)}
            name={iconName}
            size={ICON_SIZE.SIZE_20}
            socialButton
            aria={{
              label: iconName,
            }}
          />
        ))}
      </div>

      <div className="-mt10">
        <Button
          handleClick={handleInvest}
          name="Invest in SnD"
          buttonClass="ternary"
        />
      </div>
    </div>
  );
};

export default SocialInfo;
